import React from 'react';

import { createStyles } from '@mantine/core';
import BannerModal from 'components/banner/BannerModal';
import LastCreditAlertModal from 'components/LastCreditAlertModal';
import { useAuth } from 'context/auth-context';
import { LastCreditAlertProvider, useLastCreditAlert } from 'context/last-credit-alert-context';
import { Outlet } from 'react-router-dom';
import { INavLinkMobile } from 'routes/types';

import DemoGymBanner from './components/DemoGymBanner';
import Navbar from './components/Navbar';

const useStyles = createStyles(theme => ({
  layout: {
    height: '100vh',
    width: '100vw',
    maxWidth: theme.breakpoints.sm,
    margin: 'auto',
    display: 'flex',
    justifyContent: 'center',
    background: theme.colors.gray[0],
    paddingBottom: '68px',

    '.page': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      maxWidth: '100%',
      maxHeight: '100%',
      flexGrow: 1,

      '.header': {
        width: '100%',
        background: theme.white,
        padding: theme.spacing.md,
        boxShadow: theme.shadows.xs,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: theme.spacing.lg,
        marginBottom: '2px',
      },

      '.content': {
        padding: theme.spacing.md,
        overflowY: 'auto',
        flexGrow: 1,
        width: '100%',
        maxWidth: '100%',
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
      },

      '.content-no-padding': {
        overflowY: 'auto',
        flexGrow: 1,
        width: '100%',
        maxWidth: '100%',
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
      },

      '.navbar': {
        width: '100vw',
        maxWidth: theme.breakpoints.sm,
        padding: theme.spacing.xs,
        paddingTop: 0,
        position: 'fixed',
        bottom: 0,
        zIndex: 2,
      },
    },
  },
}));

const MobileLayoutContent = ({ navLinks }: { navLinks: INavLinkMobile[] }): JSX.Element => {
  const { classes } = useStyles();
  const { session } = useAuth();
  const { renewalNotification, hideRenewalNotification } = useLastCreditAlert();

  return (
    <div className={classes.layout}>
      <div className='page'>
        {!!session?.demoGym && <DemoGymBanner />}

        <Outlet />
        <Navbar linksData={navLinks} />
        <BannerModal />

        <LastCreditAlertModal alert={renewalNotification} onClose={hideRenewalNotification} />
      </div>
    </div>
  );
};

const MobileLayout = ({ navLinks }: { navLinks: INavLinkMobile[] }): JSX.Element => {
  return (
    <LastCreditAlertProvider>
      <MobileLayoutContent navLinks={navLinks} />
    </LastCreditAlertProvider>
  );
};

export default MobileLayout;
